import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'
import { authApi } from 'shared/api/auth'

import {
  PasswordRecoveryConfirmRequest,
  PasswordRecoveryConfirmResponse
} from './passwordRecoveryConfirm.types'

export const passwordRecoveryConfirm = async (
  request: PasswordRecoveryConfirmRequest
) => {
  const response = await authApi.post<PasswordRecoveryConfirmResponse>(
    'password-recovery-confirm',
    request
  )
  return response.data
}

export const usePasswordRecoveryConfirmMutation = (
  options?: ExtendableMutationOptions<
    PasswordRecoveryConfirmResponse,
    PasswordRecoveryConfirmRequest
  >
) => {
  return useMutation({
    mutationFn: passwordRecoveryConfirm,
    ...options
  })
}
